<template>
    <div id="tracking">
        <div class="text-center tracking-status-created">
            <p class="tracking-status text-tight">
                PIPELINE FOR PO:
                <slot name="purchaseorderno">Loading....</slot>
                - Ref:
                <slot name="quotationreference">Loading....</slot>
            </p>
        </div>
        <div class="tracking-list">
            <div class="tracking-item">
                <div class="tracking-icon status-created">
                    <i class="fas fa-star"></i>
                </div>
                <!-- <div class="tracking-date">Aug 10, 2018<span>05:01 PM</span></div> -->
                <div class="tracking-content">
                    <a href="#">
                        Purchase Order Assigned To 
                        <slot name="vendorname"></slot>
                        <span class="badge badge-success w-25 text-white">
                            <slot name="purchaseorderdate"></slot>
                        </span>
                        <span>
                            PR Office, Islamabad  
                        </span>
                    </a>
                   
                </div>
            </div>
            <div v-for="(challan, index) in deliveryChallans" :key="index" class="tracking-item">
                <div class="tracking-icon status-created">
                    <i class="fas fa-shipping-fast"></i>
                </div>
                <!-- <div class="tracking-date">Aug 10, 2018<span>05:01 PM</span></div> -->
                <div class="tracking-content">
                    <a :href="url + '' + challan    .Id">
                        Delivery Challan Recieved at 
                        <span class="badge badge-success w-25 text-white">
                            {{ challan.Date }} 
                        </span>
                        <span>
                            Warehouse, Islamabad    
                        </span>
                    </a>
                   
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "timeline-history-tracker-po",
        props : ['PurchaseOrderId'],
        data() {
            return {
                deliveryChallans : null,
                url: 'delivery-challan/',
            };
        },
        methods: {
            getDeliveryChallans() {
                axios.get('delivery-challan/all-delivery-challan/' + this.PurchaseOrderId)
                .then(response => {
                    this.deliveryChallans = response.data;
                    console.log(this.deliveryChallans)
                })
                .catch(error => {
                    this.errored = true
                })
                .finally(() => this.loader = false)
            },
        },
        mounted () {
            this.getDeliveryChallans();
        },
    };
</script>

<style lang="scss" scoped>
    .tracking-item > .tracking-icon > i {
        font-size: 2.33333em;
        line-height: 1.75em;
    }

    .tracking-detail {
        padding: 3rem 0
    }

    #tracking {
        margin-bottom: 1rem
    }

    [class*=tracking-status-] p {
        margin: 0;
        font-size: 1.1rem;
        color: #fff;
        text-transform: uppercase;
        text-align: center
    }

    [class*=tracking-status-] {
        padding: 1.6rem 0
    }

    .tracking-status-created {
        background-color: #65aee0
    }

    .tracking-status-outfordelivery {
        background-color: #f5a551
    }

    .tracking-status-deliveryoffice {
        background-color: #f7dc6f
    }

    .tracking-status-delivered {
        background-color: #4cbb87
    }

    .tracking-status-attemptfail {
        background-color: #b789c7
    }

    .tracking-status-error, .tracking-status-exception {
        background-color: #d26759
    }

    .tracking-status-expired {
        background-color: #616e7d
    }

    .tracking-status-pending {
        background-color: #ccc
    }

    .tracking-status-inforeceived {
        background-color: #214977
    }

    .tracking-list {
        border: 1px solid #e5e5e5
    }

    .tracking-item {
        border-left: 1px solid #e5e5e5;
        position: relative;
        padding: 2rem 1.5rem .5rem 2.5rem;
        font-size: .9rem;
        margin-left: 3rem;
        min-height: 5rem
    }

    .tracking-item:last-child {
        padding-bottom: 4rem
    }

    .tracking-item .tracking-date {
        margin-bottom: .5rem
    }

    .tracking-item .tracking-date span {
        color: #888;
        font-size: 85%;
        padding-left: .4rem
    }

    .tracking-item .tracking-content {
        padding: .5rem .8rem;
        background-color: #f4f4f4;
        border-radius: .5rem
    }

    .tracking-item .tracking-content span {
        display: block;
        color: #888;
        font-size: 85%
    }

    .tracking-item .tracking-icon {
        line-height: 2.6rem;
        position: absolute;
        left: -1.3rem;
        width: 2.6rem;
        height: 2.6rem;
        text-align: center;
        border-radius: 50%;
        font-size: 1.1rem;
        background-color: #fff;
        color: #fff
    }

    .tracking-item .tracking-icon.status-sponsored {
        background-color: #f68
    }

    .tracking-item .tracking-icon.status-delivered {
        background-color: #4cbb87
    }

    .tracking-item .tracking-icon.status-outfordelivery {
        background-color: #f5a551
    }

    .tracking-item .tracking-icon.status-deliveryoffice {
        background-color: #f7dc6f
    }

    .tracking-item .tracking-icon.status-attemptfail {
        background-color: #b789c7
    }

    .tracking-item .tracking-icon.status-exception {
        background-color: #d26759
    }

    .tracking-item .tracking-icon.status-inforeceived {
        background-color: #214977
    }

    .tracking-item .tracking-icon.status-created {
        color: #8e8e8e;
        border: 1px solid #8e8e8e;
        font-size: .6rem
    }

    @media(min-width: 992px) {
        .tracking-item {
            margin-left: 10rem
        }
        .tracking-item .tracking-date {
            position: absolute;
            left: -10rem;
            width: 7.5rem;
            text-align: right
        }
        .tracking-item .tracking-date span {
            display: block
        }
        .tracking-item .tracking-content {
            padding: 0;
            background-color: transparent
        }
    }
</style>
